import { CheckboxStyledFRDS } from './CheckboxStyledFR-DS';
import styled from '../../../styles/theme';

export const CheckboxStyledUKDS = styled(CheckboxStyledFRDS)``;
